<script>
  import FAQItem from "./FAQItem.svelte";
  import Navbar from "./Navbar.svelte";
</script>

<div class="bg-blackSplash text-white min-h-full">
  <Navbar dark={true} />
  <div class="flex font-normal justify-center">
    <div class="md:m-40 m-10">
      <h3 class="font-pixel font-light mb-20 text-6xl">FAQ</h3>
      <FAQItem title="Who is behind this?">
        <p>This is the inagural project by a collective XX__XX.</p>
        <p>
          The XX is a feminist collective re-imagining the blockchain as a
          creative medium to talk about shared experiences
        </p>
        <p>
          The founder created the genesis series through her own experiences and
          others around her.
        </p>
       
      </FAQItem>
      <FAQItem title="How were these inspired">
        <p>
          So many collectables make men feel good about being punk or cool on
          the blockchain.
        </p>
        <p>
          We wanted to tell that same story from a female perspective, leading
          to the start of the fboys project.
        </p>
        <p>
          The XX is a feminist collective re-imagining the blockchain as a
          creative medium to talk about shared experiences
        </p>
      </FAQItem>
      <FAQItem title="Why would I want one?">
        <p>They’re so cute and adorable – until you take them home!</p>
        <p>
          Preserve a memory that the collective has shared by owning a likeness
          of a fuckboy you may have encountered yourself.
        </p>
        <p>
          Owning a fboy initial launch gives access to the discord to help
          inform the future of the series.
        </p>
      </FAQItem>
      <FAQItem title="Are these an investment?">
        <p>They’re just for fun :)</p>
        <p>These should be considered to be a collection, not an investment.</p>
      </FAQItem>
      <FAQItem title="How can I contribute?">
        <p>
          Submit your own fboy ideas and sketches via twitter or email, if we draw it and mint it in our collection,
          we will split the initial sale.
        </p>
        <p>DM us on twitter (@cryptofuckboys) to submit</p>
      </FAQItem>
      <FAQItem title="What are you planning next?">
        <p>
          Owning a genesis fboy will let you learn more about early drops and possible airdrops as the fboys collection continues to grow.
        </p>
      </FAQItem>
      <FAQItem title="Why are they so cute?">
        <p>FBoys are cute, that's the point.</p>
      </FAQItem>
      <FAQItem title="How do I learn more?">
        <p>
          Message us on twitter <a
            class="underline"
            href="https://twitter.com/cryptofuckboys">@cryptofuckboys</a
          >
        </p>
      </FAQItem>
    </div>
  </div>
</div>
